import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-funfacts-style-one',
  templateUrl: './funfacts-style-one.component.html',
  styleUrls: ['./funfacts-style-one.component.scss']
})
export class FunfactsStyleOneComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
